try{self['workbox:sw:6.4.2']&&_()}catch(e){}// eslint-disable-line